import React from 'react';

export const pageMeta = {
  "name": "JS RegExp Metachars",
  "link": "/javascript/regexp/metachars"
};

export default function JavascriptRegexpMetachars() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS RegExp Metachars</h2>
      <p>Route: /javascript/regexp/metachars</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
